export { MessageCacheIndexedDB } from './message-cache-indexed-db'
import { MessageCacheIndexedDB } from './message-cache-indexed-db'
import { MessageCacheSingle } from './message-cache-single'

export const messageCache = new MessageCacheIndexedDB(100)
export const messageNotiCache = new MessageCacheSingle('bv-mesg-noti', 100)
export const rootMessageCache = new MessageCacheSingle('chat-room-root-messages', 100)
export const failedMessageCache = new MessageCacheSingle('failed-messages', 100)

